import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import { LocaleContext } from 'contexts/locale'

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<{}, State> {
  public static contextType = LocaleContext
  public state = {
    hasError: false
  }

  private messages = require('./locales/' + this.context + '.yml')

  public componentDidCatch(error, info) {
    this.setState({ hasError: true })
    console.group('ErrorBoundary')
    console.log(error, info)
    console.groupEnd()
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className='ui error icon message'>
          <i className='warning sign icon' />
          <div className='content'>
            <div className='header'>{this.messages['header']}</div>
            <p>{this.messages['body']}</p>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
